// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link-style[data-v-76d34eea]{font-size:12px}", "",{"version":3,"sources":["webpack://./src/components/createTable/renderBtn.vue"],"names":[],"mappings":"AACA,6BACE,cAAA","sourcesContent":["\n.link-style {\n  font-size: 12px;\n  /* margin-right: 8px; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
